module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('control'), _vm._v(" "), _c('field')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-479b49d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 103
// module chunks = 1